/**
 * Shipping Charges A/B test helpers.
 *
 * Single source of truth for the variant detection is
 * `snippets/is-ship-test-b-variant.liquid`, surfaced to JS via
 * `window.Boarderie.shipTest` in `snippets/boarderie-critical-data.liquid`.
 * The bridge is an inline non-module script and runs before any deferred
 * module import, so this file never needs to know the theme name string.
 *
 * When the test ends:
 *   1. Delete this file and `snippets/is-ship-test-b-variant.liquid`.
 *   2. Remove the `window.Boarderie.shipTest` block from the data bridge.
 *   3. `grep shiptest` / `grep shipTest` to find and clean every call site.
 */
import { cartActions } from './cart-utils';

export const isShipTestBVariant = () => window.Boarderie?.shipTest?.isB === true;

export const getShipTestVariant = () => (isShipTestBVariant() ? 'B' : 'A');

const isMainProduct = (item) => {
  const type = item.properties?._type;
  return type !== 'addon' && type !== 'fee';
};

export const backfillShipTestOnCart = async (cartObject) => {
  const variant = getShipTestVariant();

  const itemsToPatch = (cartObject?.items || []).filter(
    (item) => isMainProduct(item) && !item.properties?._shiptest
  );

  for (const item of itemsToPatch) {
    const properties = { ...item.properties, _shiptest: variant };
    try {
      await cartActions.change(JSON.stringify({ id: item.key, properties }));
    } catch (error) {
      console.error('[shiptest] backfill failed for item', item.key, error);
    }
  }
};
